import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@ninety/ui/web/environments';

export interface ScheduleCalendarBotResponse {
  status: 'scheduled' | 'pendingSync' | 'notConnected';
  recallCalendarEventId?: string;
}

@Injectable({
  providedIn: 'root',
})
export class RecallCalendarService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.meetingAgentApiOrigin}/v1/meeting-schedule`;

  scheduleBot(
    meetingScheduleId: string,
    extMeetingUrl: string,
    ninetyMeetingUrl?: string,
    calendarProvider?: 'google-calendar' | 'microsoft-outlook'
  ): Observable<ScheduleCalendarBotResponse> {
    return this.http.post<ScheduleCalendarBotResponse>(`${this.baseUrl}/${meetingScheduleId}/bot`, {
      extMeetingUrl,
      ...(ninetyMeetingUrl ? { ninetyMeetingUrl } : {}),
      ...(calendarProvider ? { calendarProvider } : {}),
    });
  }

  // Best-effort: called on every schedule-start regardless of whether that schedule ever had a
  // bot scheduled against it. Lets meeting-agent's status webhook resolve a meetingId for a
  // calendar-scheduled bot, which carries no meetingId of its own (see
  // docs/calendar-scheduling-architecture.md in meeting-agent).
  linkMeeting(meetingScheduleId: string, meetingId: string): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/${meetingScheduleId}/meeting`, { meetingId });
  }

  // Best-effort: called when a schedule is fully deleted, regardless of whether it ever had a bot
  // scheduled against it (meeting-agent no-ops harmlessly when there's nothing to unschedule).
  // Deletes the Recall bot for the matched calendar event and the local mapping.
  unscheduleBot(meetingScheduleId: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${meetingScheduleId}/bot`);
  }
}
